import React from "react";

interface TotalDisplayProps {
  label: string;
  value: string | number;
}

const TotalDisplay = ({ label, value }: TotalDisplayProps) => (
  <div className="flex items-center flex-col md:flex-row">
    <p className="w-full">{label} </p>
    <p className="w-full text-center">{value}</p>
  </div>
);

export default TotalDisplay;
